import React from "react";

export const MapsLoadedContext = React.createContext<{ isLoaded: boolean; loadError: Error | undefined }>({
    isLoaded: false,
    loadError: undefined,
});